import { defineRoute } from '../defineRoute';

export type MyDashboardRouteParams = {
  // ...
};

export type MyDashboardRouteParamsString = {
  // ...
};

export const MyDashboard = defineRoute<
  MyDashboardRouteParams,
  MyDashboardRouteParamsString
>({
  pathname: '/dashboard',
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
